import { useCallback } from 'react';
import RadioButton from '../RadioButton';
import useRadioButtonFilters from '../../hooks/useRadioButtonFilters';
import styles from './RadioFilterGroup.scss';

export default function RadioFilterGroup({
  name,
  label,
  options,
  onChange = () => {},
}) {
  const [filters, handleFilterChange] = useRadioButtonFilters(options);

  const handleChange = useCallback(
    value => {
      handleFilterChange(value);
      onChange(value);
    },
    [handleFilterChange, onChange]
  );

  const filterReturn = filters.map(filter => (
    <RadioButton
      {...filter}
      name={name}
      id={filter.name}
      key={filter.name}
      onChange={handleChange}
    />
  ));
  return (
    <form>
      <fieldset>
        <div className={styles.fieldsetInner}>
          <legend className={styles.legend}>{label}</legend>
          {filterReturn}
        </div>
      </fieldset>
    </form>
  );
}
